import {
  flow,
  SnapshotIn,
} from 'mobx-state-tree';
import Hades from '@services/Hades';
import { IOrganizations } from '@stores/ApplicationInterfaces';
import Organization from '@stores/Organization';
import { getOrganizationWithGroups } from '@utils/mst/organizationalHelpers';

export default {
  actions: (self: { hades: Hades; organizations: IOrganizations }) => ({
    createOrganization: flow(function* createOrganization({
      industry,
      name,
      groupIds,
      defaultOrgGroupId,
    }) {
      const result: SnapshotIn<typeof Organization> = yield self.hades.request(
        'organization.create',
        {
          industry,
          name,
          orgGroupIds: groupIds,
          defaultOrgGroupId,
        },
      );

      if (result) {
        const organizationWithGroups = getOrganizationWithGroups(result, null, groupIds, defaultOrgGroupId);
        self.organizations.set(`${result.id}`, organizationWithGroups);
      }

      return result;
    }),

    updateOrganization: flow(function* updateOrganization({
      industry,
      name,
      organizationId,
      groupIds,
      defaultOrgGroupId,
    }) {
      const result: SnapshotIn<typeof Organization> = yield self.hades.request(
        'organization.update',
        {
          industry,
          name,
          organizationId,
          orgGroupIds: groupIds,
          defaultOrgGroupId,
        },
      );

      if (result) {
        const organization = self.organizations.get(`${organizationId}`);
        const organizationWithGroups = getOrganizationWithGroups(result, organization, groupIds, defaultOrgGroupId);
        self.organizations.set(`${organizationId}`, organizationWithGroups);
      }

      return result;
    }),
    activateOrganization: flow(function* activateOrganization({ id }: { id: string | number }) {
      const result: SnapshotIn<typeof Organization> = yield self.hades.post(`/organizations/${id}/activate`);

      const organization = self.organizations.get(`${id}`);
      if (organization && result) {
        const organizationWithGroups = getOrganizationWithGroups(result, organization);
        self.organizations.set(`${id}`, organizationWithGroups);
      }
    }),
    deactivateOrganization: flow(function* deactivateOrganization({ id }) {
      const result: SnapshotIn<typeof Organization> = yield self.hades.post(`/organizations/${id}/deactivate`);

      const organization = self.organizations.get(id);
      if (organization && result) {
        const organizationWithGroups = getOrganizationWithGroups(result, organization);
        self.organizations.set(id, organizationWithGroups);
      }
    }),
  }),
};
